import { IconButton } from 'omakase';
import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { getPlaylistType } from 'utils/profileUtils';
import { useSelector } from 'react-redux';
import PlaylistTypeIcon from 'components/profile/playlists/PlaylistTypeIcon';
import React from 'react';

interface SaveBusinessProps {
  business: core.IBusiness;
  onOpenDialog(): void;
}
const SaveBusiness: React.FunctionComponent<SaveBusinessProps> = ({ business, onOpenDialog }) => {
  const { playlists } = useSelector((state: StoreType) => ({
    playlists: state.patron.playlists.data,
    patron: state.app.patron,
  }));

  // todo make this smarter with precedence if saved to multiple lists
  const savedToList = playlists?.find(
    (playlist) => playlist.items.findIndex((item) => item.business?.id === business.id) !== -1
  );

  const savedToListType = savedToList && getPlaylistType(savedToList);
  return (
    <IconButton variant="basic" size="medium" onClick={onOpenDialog} aria-label="Favorite">
      <PlaylistTypeIcon filled={!!savedToListType} playlistType={savedToListType} />
    </IconButton>
  );
};

export default SaveBusiness;
